//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { PropsMixin, ModelMixin } from '../mixins';

export default {
  mixins: [PropsMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: [String, Number, Boolean],
      default: '',
    },
  },
};
